import { getRutilusGraphqlClient } from '../../api/graphql/getRutilusGraphqlClient';
import { handleApolloErrorOnClient } from '../../api/graphql/shared';
import { GetCurrentUser, GetCurrentUser_currentUser } from '../../interfaces/graphql';
import { getCurrentUser } from '../../queries/rutilus/Me';
import { _getToken } from '../authentication/authentication';

export const loadCurrentUser = async (): Promise<GetCurrentUser_currentUser | null> => {
  const client = getRutilusGraphqlClient();
  const { data, error } = await client.query<GetCurrentUser>({
    context: { getAuthToken: async () => _getToken() },
    errorPolicy: 'none',
    fetchPolicy: 'network-only',
    query: getCurrentUser,
  });

  if (error) {
    handleApolloErrorOnClient(error, getCurrentUser, {}, 'rutilus');
  }

  return data.currentUser;
};
